<template>
  <gg-modal :is-active="isActive" v-if="isActive" @close="closeModal">
    <template #toolbar>
      Create Staging
    </template>
    <template #body>
      <v-row>
        <v-col cols="12" md="6">
          <gg-input-label class="d-block pb-1">
            Select domain
          </gg-input-label>
          <domain-select :remote_domain="selectedDomainGetter" outlined no-label @input="setDomain" />
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field label="Directory" v-model="model.softdirectory">
            <template v-slot:append-outer>
              <v-tooltip
                bottom
                max-width="300"
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>

                The directory is relative to your domain and <b>should not exist</b>.
                e.g. To install at http://mydomain/dir/ just type <b>dir</b>.
                To install only in http://mydomain/ leave this empty.
              </v-tooltip>
            </template>
          </gg-text-field>
        </v-col>
        <v-col cols="12" md="6" v-if="selectedService">
          <gg-text-field label="Database name"
                         v-model="model.softdb"
                         :prefix="selectedService.dbprefix"
                         v-validate="'required|max:7'"
                         name="database"
                         :error-messages="errors.collect('database')"
                         data-vv-as="Database Name"
          >
            <template v-slot:append-outer>
              <v-tooltip
                bottom
                max-width="300"
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>

                Type the name of the database to be created for the installation
              </v-tooltip>
            </template>
          </gg-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <gg-text-field label="Site name"
                         v-model="model.site_name"
                         name="sitename"
                         :error-messages="errors.collect('sitename')"
                         data-vv-as="Site Name"
          >
            <template v-slot:append-outer>
              <v-tooltip
                bottom
                max-width="300"
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>

                Enter Site Name for your new site. If you want to use the same site name as the source site leave
                this field blank.
              </v-tooltip>
            </template>
          </gg-text-field>
        </v-col>
        <v-col cols="12">
          <v-checkbox label="Disable Search Engine Visibility" v-model="model.no_search_engine" true-value="off"
                      false-value="on">
            <template v-slot:append>
              <v-tooltip
                bottom
                max-width="300"
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>

                If checked then this shall discourage search engines from
                indexing this site. It is up to search engines to honor this request.
              </v-tooltip>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </template>
    <template #actions>
      <gg-btn secondary @click="closeModal">Cancel</gg-btn>
      <gg-btn :loading="loading" :disabled="loading" @click="setStage">Create</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import DomainSelect from '@/components/Common/DomainSelect'

export default {
  name: 'CreateStagingModal',
  components: {
    DomainSelect
  },
  props: {
    isActive: {
      type: Boolean,
      requred: true,
      default: false
    },
    services: {
      type: Array,
      required: true
    },
    service: {
      type: Object
    }
  },
  data: () => {
    return {
      loading: false,
      model: {
        softdirectory: '',
        softdb: '',
        no_search_engine: 'off',
        site_name: '',
        softsubmit: 'Clone',
        stagingins: 'Create+Staging',
      },
      selectedDomain: ''
    }
  },
  computed: {
    listDomains () {
      return this.services.map(item => {
        return {
          domain: item.softdomain.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0],
          ...item
        }
      })
    },
    selectedDomainGetter () {
      return this.selectedDomain.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0]
    },
    selectedService () {
      const index = this.listDomains.findIndex(item => item.domain === this.selectedDomain)

      if (index === -1) {
        return null
      }

      return this.listDomains[index]
    }
  },
  mounted () {
    this.setInitialDomain()
    this.model.softdb = this.mysqlNameGenerator()
  },
  methods: {
    ...mapActions({
      getInstallationsList: 'hosting_wp/getInstallationsList',
      setStaging: 'hosting_wp/setStaging',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    setInitialDomain () {
      this.selectedDomain = this.service.softdomain
    },
    setDomain (service) {
      if (!service) {
        return
      }
      this.selectedDomain = service
    },
    mysqlNameGenerator () {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const length = 5

      let result = ''
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }

      return result
    },
    async setStage () {
      try {
        const isValid = await this.$validator.validateAll()

        if (!isValid) {
          return
        }

        this.loading = true

        await this.setStaging({
          insid: this.selectedService.insid,
          _username: this.$route.params.user,
          payload: {
            softdomain: this.selectedDomain,
            ...this.model
          }
        })

        await this.getInstallationsList()
        this.closeModal()
        this.reportSuccess('Congratulations, the staging was created successfully')
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },

    closeModal () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
